import React from 'react';
import { motion } from 'framer-motion';

const keywords = [
  "Caretaker Elderly/patient",
  "caretaker near me",
  "nursing bureau in mumbai",
  "patient caretaker in mumbai",
  "care giver at home",
  "patient care taker services in mumbai",
  "old age care taker at home",
  "caretakers for elderly in mumbai",
  "in home elderly care in mumbai",
  "at home nurse services",
  "Baby/Japa maid",
  "baby care in mumbai",
  "japa maid agency in mumbai",
  "baby care near me",
  "japa maid near me",
  "nanny services in mumbai"
];

const KeywordMarquee = () => {
  return (
    <div className="bg-blue-600 text-white py-3 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <motion.div
          className="flex whitespace-nowrap"
          animate={{
            x: ['0%', '-100%']
          }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: 30,
              ease: "linear"
            }
          }}
        >
          {[...keywords, ...keywords].map((keyword, index) => (
            <div key={index} className="inline-flex items-center mx-8">
              <span className="text-sm font-medium">{keyword}</span>
              {index < keywords.length * 2 - 1 && (
                <div className="w-1 h-1 bg-white rounded-full mx-8 opacity-60" />
              )}
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default KeywordMarquee;